
const IS_BROWSER = typeof window !== 'undefined';
const MOUNT_ID = 'root';

import React from 'react';

import { createApp, bootstrap } from '@modern-js/runtime';

import App from '@_modern_js_src/pages/_app.tsx';

import { routes } from '@_modern_js_internal/main/routes.js';

import { router } from '@modern-js/runtime/plugins';


let AppWrapper = null;

function render() {
  
  AppWrapper = createApp({
    plugins: [
     router({...{"supportHtml5History":false,"historyOptions":{"basename":"/"},"routesConfig": { routes, globalApp: App },}, ...App?.config?.router}),
    ]
  })()

  if (IS_BROWSER) {
    bootstrap(AppWrapper, MOUNT_ID);
  }

  return AppWrapper

}

AppWrapper = render();

export default AppWrapper;;
